/**
 * PATH: apps/billing/src/pages/BookkeepingPage.tsx
 * FILE_ID: BILLING-PAGE-BOOKKEEPING-001
 * PURPOSE: Mount the shared 3-pane Bookkeeping Workspace with a deep-linkable
 *          ?id= URL param so refresh/back/forward keep selection.
 *
 * WHY: The workspace component itself stays pure — it asks the parent for an
 *      `initialBillId` and emits `onSelectionChange`. This page wires that to
 *      the URL via `useSearchParams`, so a refresh restores the selected bill
 *      and a shared link opens the same context for another user.
 *
 * FLOW:
 *   URL ?id=xyz   ──► initialBillId ──► <BookkeepingWorkspace>
 *        ▲                                       │
 *        └────────── onSelectionChange ──────────┘
 */
import { useSearchParams } from 'react-router-dom';
import { BookkeepingWorkspace } from '@quotech/bills';

export default function BookkeepingPage() {
  const [params, setParams] = useSearchParams();
  const billId = params.get('id') || null;

  function handleSelectionChange(next: string | null) {
    const updated = new URLSearchParams(params);
    if (next) updated.set('id', next);
    else updated.delete('id');
    // replace=true so the back button goes to the previous page
    // (not through every selected bill the user clicked).
    setParams(updated, { replace: true });
  }

  return (
    <div className="h-full w-full">
      <BookkeepingWorkspace
        initialBillId={billId}
        onSelectionChange={handleSelectionChange}
      />
    </div>
  );
}
